// src/modules/operaciones/inventarios/utils/negativosComun.js
export const API_URL = `${process.env.REACT_APP_API_URL || "http://localhost:5000"}/api/invent`;
export const POR_PAGINA = 50;
export const POLL_MS = 5000;
export const POLL_MAX_MS = 3 * 60 * 1000;

export const pedirJson = async (url, signal) => {
  const res = await fetch(url, { signal });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data.success) throw new Error(data.error || `HTTP ${res.status}`);
  return data;
};

export const colorSaldo = (n) => (n < 0 ? "text-red-500" : n > 0 ? "text-blue-500" : "text-gray-400");